import LoadingDots from './LoadingDots.vue'

export default {
    'tl-loading-dots': LoadingDots,
}
